module.exports = __webpack_public_path__ + "static/media/icon-laundry.0385b537.svg";